<template lang="pug">
    div(ref="editDateLocal" class="pa-2" :style="`top:${top - 120}px;`" style="position:absolute; background-color:#F0F0F0; border:1px solid grey;")
        div
            input(type="text" ref="dateInputElement" v-model="date" class="pl-1" style="background-color:white; border:1px solid grey;")
        div(class="mt-2")
            v-btn(@click="close()" elevation="0" small style="border:1px solid grey;") Cancel
            v-btn(@click="saveDate()" elevation="0" small class="green3 white--text ml-2" style="border:1px solid grey;") Save
</template>

<script>
import { mapMutations } from 'vuex';
import ApiService from './../Services/ApiService';

export default {
    name: 'EditJournalDate',
    props: {
        top: Number,
        insider: Object
    },
    data() {
        return {
            date: this.insider.date_created
        };
    },
    mounted() {
        window.addEventListener('mouseup', this.removeEditDate);
    },
    beforeDestroy() {
        console.log('beforeDestroy');
        window.removeEventListener('mouseup', this.removeEditDate);
    },
    watch: {
        insider() {
            this.date = this.insider.date_created;
        }
    },
    methods: {
        ...mapMutations([
            'updateMapUserDiaryItem'
        ]),
        removeEditDate(e) {
            console.log('removeEditDate');

            if(this.$refs.editDateLocal !== undefined) {
                const element = this.$refs.editDateLocal;

                if(!element.contains(e.target)) {
                    console.log('outside');

                    this.$parent.showEditDate = false;
                }

                console.log(this.$parent.showEditDate);
            }
        },
        async saveDate() {
            const data = {
                diary_item_id: this.insider.diary_item_id,
                date_created: this.date
            };

            await ApiService.updateDiaryItem(data);

            this.updateMapUserDiaryItem(Object.assign({}, data, { key: 'date_created' }));

            this.$emit('updateChart');

            this.$parent.showEditDate = false;
        },
        close() {
            this.$parent.showEditDate = false;
        }
    }
}
</script>

<style scoped>
input:focus {
    outline: none !important;
}
</style>
